// Cart helpers (localStorage)
const KEY = "aabb_cart_v1";
export const getCart = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
export const setCart = (items) => localStorage.setItem(KEY, JSON.stringify(items));
export const addToCart = (item) => {
  const c = getCart();
  const idx = c.findIndex((i) => i.sku === item.sku);
  if (idx >= 0) c[idx].qty += 1; else c.push({ ...item, qty: 1 });
  setCart(c); window.dispatchEvent(new Event("cart-updated"));
};
export const removeFromCart = (sku) => {
  setCart(getCart().filter((i) => i.sku !== sku));
  window.dispatchEvent(new Event("cart-updated"));
};
export const cartTotal = () => getCart().reduce((s, i) => s + i.price_cents * i.qty, 0);
export const clearCart = () => { localStorage.removeItem(KEY); window.dispatchEvent(new Event("cart-updated")); };
export const formatPrice = (cents) => `$${(cents/100).toFixed(2)}`;
